import IconComponent from "@mdi/react";
import { SortableHeaderCell } from "react-data-grid";

import { mdiContentCopy } from "@mdi/js";
import { Alert, Button, Popover } from "antd";
import styled from "styled-components";

import { Tooltip } from "../../../../../components/base";
import { HeaderRendererProps } from "../../../../../components/data-table/types";

interface CreateHeaderRendererOptions {
  hasTrialAccount: boolean;
  isReadonly: boolean;
  activeColumnCopyAlerts: Record<string, boolean>;
  onColumnCopy: (columnName: string, columnKey: string) => void;
  onHeaderContextMenu: (
    event: React.MouseEvent,
    columnName: string,
    columnKey: string
  ) => void;
}

export function createChartDataTableHeaderRenderer({
  hasTrialAccount,
  isReadonly,
  activeColumnCopyAlerts,
  onColumnCopy,
  onHeaderContextMenu
}: CreateHeaderRendererOptions) {
  return function HeaderRenderer(props: HeaderRendererProps<Record<string, unknown>>) {
    const handleColumnCopyClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      const columnName = typeof props.column.name === "string" ? props.column.name : "";
      onColumnCopy(columnName, props.column.key);
    };

    const handleContextMenu = (event: React.MouseEvent) => {
      if (hasTrialAccount || isReadonly) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      const columnName = typeof props.column.name === "string" ? props.column.name : "";
      onHeaderContextMenu(event, columnName, props.column.key);
    };

    return (
      // @ts-expect-error - SortableHeaderCell from canary version has type mismatches
      <SortableHeaderCell {...props}>
        <HeaderContainer
          title={props.column.name?.toString() ?? ""}
          onContextMenu={handleContextMenu}
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: "100%",
            position: "fixed",
            left: "0px",
            right: "0px",
            textIndent: "5px"
          }}>
          {props.column.name}
          {!hasTrialAccount && !isReadonly && (
            <Tooltip title="Copy Column Data">
              <Popover
                open={activeColumnCopyAlerts[props.column.key] || false}
                trigger="click"
                overlayClassName="overlay-no-padding"
                content={<Alert type="success" message="Column Copied to Clipboard!" />}>
                <CopyButton onClick={handleColumnCopyClick}>
                  <IconComponent path={mdiContentCopy} size={0.8} />
                </CopyButton>
              </Popover>
            </Tooltip>
          )}
        </HeaderContainer>
      </SortableHeaderCell>
    );
  };
}

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  position: relative;
`;

const CopyButton = styled(Button)`
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(255, 255, 255, 0.95);
  border: 1px solid #d9d9d9;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s;
  opacity: 0;
  pointer-events: none;
  z-index: 10;

  ${HeaderContainer}:hover & {
    opacity: 1;
    pointer-events: auto;
  }

  &:hover {
    background-color: #f0f0f0 !important;
    border-color: #40a9ff !important;
    color: #40a9ff;
    transform: translateY(-50%) scale(1.1);
  }

  &:focus {
    opacity: 1;
    pointer-events: auto;
    background-color: #e6f7ff !important;
    border-color: #40a9ff !important;
  }
`;
